export const sanitizeConfig = {
  allowedTags: [
    'iframe',
    'audio',
    'img',
    'address',
    'article',
    'aside',
    'footer',
    'header',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'hgroup',
    'main',
    'nav',
    'section',
    'blockquote',
    'dd',
    'div',
    'dl',
    'dt',
    'figcaption',
    'figure',
    'hr',
    'li',
    'main',
    'ol',
    'p',
    'pre',
    'ul',
    'a',
    'abbr',
    'b',
    'bdi',
    'bdo',
    'cite',
    'code',
    'data',
    'dfn',
    'em',
    'i',
    'kbd',
    'mark',
    'q',
    'rb',
    'rp',
    'rt',
    'rtc',
    'ruby',
    's',
    'samp',
    'small',
    'span',
    'strong',
    'sub',
    'sup',
    'time',
    'u',
    'var',
    'wbr',
    'caption',
    'col',
    'colgroup',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'tr',
    'br',
    'svg',
    'path',
    'g',
    'defs',
    'linearGradient',
    'stop',
    'circle',
  ],
  allowedAttributes: {
    '*': ['id', 'fill', 'd', 'transform'],
    svg: ['xmlns', 'width', 'height', 'viewBox', 'style'],
    audio: ['src', 'controls'],
    iframe: [
      'src',
      'frameborder',
      'allowfullscreen',
      'id',
      'type',
      'width',
      'height',
      'class',
      'frameborder',
      'allow',
      'controls',
      'color',
    ],
    a: ['href', 'name', 'target'],
    span: ['style'],
    table: ['style', 'border'],
    tr: ['style'],
    td: ['style'],
    // We don't currently allow img itself by default, but
    // these attributes would make sense if we did.
    img: [
      'style',
      'src',
      'srcset',
      'alt',
      'title',
      'width',
      'height',
      'data-zoom-src',
      'class',
    ],
  },
  parser: {
    lowerCaseTags: false,
    lowerCaseAttributeNames: false,
  },
};
